// extracted by mini-css-extract-plugin
export default {"shadow":"devices_shadow__qjf+5","border":"devices_border__2Z3t6","devices":"devices_devices__OTEn5","wrapper":"devices_wrapper__zGAT0"};